import React from "react";
import "./ConfirmDeleteModal.css";

const ConfirmDeleteModal = ({ show, onClose, onConfirm, studyName , type }) => {
  if (!show) return null;

  return (
    <div className="confirm-modal-backdrop">
      <div className="modal-container">
        <h5 className="fw-semibold mb-3">Confirmation de suppression</h5>
        <p>
          Êtes-vous sûr de vouloir supprimer {type}{" "}
          <strong>{studyName}</strong> ?
        </p>
        <div className="d-flex justify-content-end mt-4 gap-2">
          <button className="deny btn" onClick={onClose}>
            Annuler
          </button>
          <button className="accept btn" onClick={onConfirm}>
            Supprimer
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
